import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgSelectModule, NgSelectComponent } from '@ng-select/ng-select';
import { SunleonService } from '../../../sunleon/data-access/http/sunleon.service';
import { SessionSummaryDto } from 'src/app/sunleon/data-access/http/dto/session-summary-dto';
import { SessionSaveDto } from 'src/app/sunleon/data-access/http/dto/session-save-dto';

@Component({
  selector: 'app-simulation-enregistre',
  templateUrl: './simulation-enregistre.component.html',
  styleUrls: ['./simulation-enregistre.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule],
})
export class SimulationEnregistreComponent implements OnInit {
  @Output() scenarioSelected = new EventEmitter<SessionSaveDto>();
  @ViewChild(NgSelectComponent) ngSelect!: NgSelectComponent;

  summaries: SessionSummaryDto[] = [];
  filteredSummaries: SessionSummaryDto[] = [];
  selectedId: number | null = null;
  loading: boolean = false;
  filterId: string = '';
  filterNomProjet: string = '';
  filterNomUtilisateur: string = '';
  filterPrenomUtilisateur: string = '';
  filterDate: string = '';

  private activeInput: HTMLInputElement | null = null;

  constructor(private sunleonService: SunleonService) {}

  ngOnInit(): void {
    this.loading = true;
    this.sunleonService.getSessionsSummaries().subscribe((data: SessionSummaryDto[]) => {
      this.summaries = data;
      this.filteredSummaries = data;
      this.loading = false;
    });
  }

  onInputFocus(event: FocusEvent): void {
    this.activeInput = event.target as HTMLInputElement;
  }

  customSearchFn(term: string, item: SessionSummaryDto): boolean {
    const searchTerm = term.toLowerCase().trim();
    const matchesNomProjet = item.nomProjet?.toLowerCase().includes(searchTerm) || false;
    const matchesId = item.id.toString().includes(searchTerm);
    const matchesNomUtilisateur = item.nomUtilisateur?.toLowerCase().includes(searchTerm) || false;
    const matchesPrenomUtilisateur = item.prenomUtilisateur?.toLowerCase().includes(searchTerm) || false;
    const matchesDate = item.createdDate?.split(',').slice(0, 3).join('-').includes(searchTerm) || false;
    return matchesNomProjet || matchesId || matchesNomUtilisateur || matchesPrenomUtilisateur || matchesDate;
  }

  updateFilteredSummaries(): void {
    const filtered = this.summaries.filter(item => {
      const matchesId = this.filterId
        ? item.id.toString().toLowerCase().includes(this.filterId.toLowerCase().trim())
        : true;
      const matchesNomProjet = this.filterNomProjet
        ? item.nomProjet?.toLowerCase().includes(this.filterNomProjet.toLowerCase().trim())
        : true;
      const matchesNomUtilisateur = this.filterNomUtilisateur
        ? item.nomUtilisateur?.toLowerCase().includes(this.filterNomUtilisateur.toLowerCase().trim())
        : true;
      const matchesPrenomUtilisateur = this.filterPrenomUtilisateur
        ? item.prenomUtilisateur?.toLowerCase().includes(this.filterPrenomUtilisateur.toLowerCase().trim())
        : true;
      const matchesDate = this.filterDate
        ? this.parseDateString(item.createdDate) === this.filterDate
        : true;
      return matchesId && matchesNomProjet && matchesNomUtilisateur && matchesPrenomUtilisateur && matchesDate;
    });

    this.filteredSummaries = this.sortByDateDesc(filtered);

    if (this.ngSelect && (this.filterId || this.filterNomProjet || this.filterNomUtilisateur || this.filterPrenomUtilisateur || this.filterDate)) {
      this.ngSelect.open();
      if (this.activeInput) {
        setTimeout(() => {
          this.activeInput?.focus();
        }, 0);
      }
    }
  }

  private parseDateString(dateValue: any): string {
    if (!dateValue) return '';

    if (Array.isArray(dateValue)) {
      const [year, month, day] = dateValue;
      return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
    }

    if (typeof dateValue === 'string') {
      return dateValue.split('T')[0];
    }

    return '';
  }

  applySimulation(): void {
    if (this.selectedId !== null) {
      this.sunleonService.getSessionEntree(this.selectedId).subscribe((scenario: SessionSaveDto) => {
        this.scenarioSelected.emit(scenario);
      });
    }
  }

  private sortByDateDesc(items: SessionSummaryDto[]): SessionSummaryDto[] {
    return [...items].sort((a, b) => {
      const dateA = a.createdDate ? new Date(a.createdDate).getTime() : 0;
      const dateB = b.createdDate ? new Date(b.createdDate).getTime() : 0;
      return dateB - dateA;
    });
  }
}
